import React from 'react';
import { Box } from '@mui/material';

interface MultiSelectOptionFieldProps {
    children: React.ReactNode;
}

/**
 * Multi-select option field.
 */
const MultiSelectOptionField: React.FC<MultiSelectOptionFieldProps> = ({ children }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                mb: 0.25,
            }}
        >
            {children}
        </Box>
    );
};

export default MultiSelectOptionField;
